import { useQuery } from '@apollo/client';

import GrowthEpicClient from 'bundles/epic/clients/Growth';
import QueryLearningHours from 'bundles/s12n-common/api/LearningHoursQuery.graphql';
import type {
  LearningHoursQuery,
  LearningHoursQueryVariables,
} from 'bundles/s12n-common/api/__generated__/LearningHoursQuery';

function useFetchLearningHours(slug: string, type: 'S12N' | 'COURSE') {
  const learningHoursEnabled = GrowthEpicClient.get('learningHours');
  const jobName = type === 'S12N' ? 's12n_learning_hours' : 'course_learning_hours';

  const { data, loading, error } = useQuery<LearningHoursQuery, LearningHoursQueryVariables>(QueryLearningHours, {
    variables: { key: slug, jobName },
    context: { clientName: 'gatewayGql' },
    skip: !slug || !learningHoursEnabled,
    ssr: true,
    errorPolicy: 'all',
  });

  let overridingHours: number | null = null;
  const entry = data?.NaptimeQueries?.ExternallyAccessibleNostosV1Resource?.getAllProperties?.elements?.[0];
  if (!loading && !error && entry?.content) {
    // we create an impresion after we know that the course/s12n has overriding data
    // this way, we avoid generating impressions when we wouldn't have shown different data
    const variant = GrowthEpicClient.get('learningHoursVariant', { slug, type });
    if (variant === 'VARIANT_25') {
      overridingHours = entry.content.lhP25;
    } else if (variant === 'VARIANT_50') {
      overridingHours = entry.content.lhP50;
    } else if (variant === 'VARIANT_75') {
      overridingHours = entry.content.lhP75;
    }
  }

  return [overridingHours, loading] as const;
}

export { useFetchLearningHours };
